import { MapPinIcon, PhoneIcon, EnvelopeIcon, ClockIcon } from '@heroicons/react/24/outline';
import PublicLayout from './PublicLayout';

// Placeholder details — replace with the school's actual contact information.
const contactDetails = [
  { icon: MapPinIcon, label: 'Address', value: 'Calauag National High School, Maharlika Highway, Brgy. Sta. Maria, Calauag, Quezon' },
  { icon: PhoneIcon, label: 'Phone', value: '09xx-xxx-xxxx' },
  { icon: EnvelopeIcon, label: 'Email', value: 'your email here' },
  { icon: ClockIcon, label: 'Office Hours', value: 'Monday–Friday, 8:00 AM–5:00 PM' },
];

function ContactPage() {
  return (
    <PublicLayout>
      <div className="w-full space-y-4">
        <section className="w-full bg-white rounded-lg border border-gray-200 p-4">
          <p className="-mx-4 -mt-4 mb-3 rounded-t-lg bg-navy-light px-4 py-2 text-md lg:text-lg font-semibold text-white tracking-wide">
            CONTACT US
          </p>

          <p className="text-sm text-gray-500 mb-4">
            Have questions about your child's SPTA contributions or an ongoing project? Reach the SPTA
            office through any of the channels below.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {contactDetails.map(({ icon: Icon, label, value }) => (
              <div key={label} className="flex items-start gap-3 border border-gray-200 rounded-lg p-4">
                <Icon className="h-6 w-6 text-navy-light shrink-0" />
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">{label}</p>
                  <p className="text-gray-900 font-medium">{value}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </PublicLayout>
  );
}

export default ContactPage;
